
// sidebar.component.ts

import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';

import { AdminAlertsService } from '../../core/services/admin-alerts.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, MatListModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  unreadAlertsCount = 0;
  isSuperAdmin = false;

  constructor(
    private adminAlertsService: AdminAlertsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.isSuperAdmin = this.authService.getRole() === 'superadmin';
    if (this.isSuperAdmin) {
      this.getUnreadCount();
    }
  }

  getUnreadCount() {
    this.adminAlertsService.getUnreadCount().subscribe({
      next: (res) => this.unreadAlertsCount = res.unread,
      error: () => this.unreadAlertsCount = 0
    });
  }
}
